<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Number format for this field']"
    >
    <mat-icon fontIcon="123"></mat-icon>
    <h3>
      Format number field
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand_more"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      @if (percentageFieldEnabled()) {
        <tr>
          <td>
            <mat-slide-toggle [(ngModel)]="isPercentage" (change)="updateConfig()">Percentage field?</mat-slide-toggle>
          </td>
        </tr>
        <tr class="grey">
          <td>Value multiplied by 100, e.g. 0.2 shows as 20.00</td>
        </tr>
      }
      <tr class="decimal-grid">
        <td>To</td>
        <td>
          <input type="number" title="How many decimal places to show" min="0" [(ngModel)]="exactDecimalDigits" (change)="updateConfig()" />
        </td>
        <td>decimal places</td>
      </tr>
      <tr>
        <td><p>Decimal and thousands separator styles</p></td>
      </tr>
      <tr class="button-toggle-grid">
        <td>Decimal</td>
        <td>
          <mat-button-toggle-group
            name="decimalStyle"
            aria-label="Decimal style"
            [(ngModel)]="decimalSeparator"
            (change)="updateConfig()"
            [hideSingleSelectionIndicator]="true"
            >
            <mat-button-toggle [value]="NumberFormatSeparator.POINT">2.01</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.COMMA">2,01</mat-button-toggle>
          </mat-button-toggle-group>
        </td>
      </tr>
      <tr class="button-toggle-grid">
        <td>Thousands</td>
        <td>
          <mat-button-toggle-group
            class="thousands-toggle"
            name="thousandsStyle"
            aria-label="Decimal style"
            [(ngModel)]="thousandsSeparator"
            (change)="updateConfig()"
            [hideSingleSelectionIndicator]="true"
            >
            <mat-button-toggle [value]="NumberFormatSeparator.POINT">1.000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.COMMA">1,000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.NONE">1000</mat-button-toggle>
            <mat-button-toggle [value]="NumberFormatSeparator.WHITESPACE">1 000</mat-button-toggle>
          </mat-button-toggle-group>
        </td>
      </tr>
      <tr class="grey">
        <td>
          e.g. UK/US style: 1,000,000.00
          <br />European style: 1.000.000,00
        </td>
      </tr>
    </table>
  }
</section>
